<div class="compose-fax-container">
  <div class="menu">
    <span class="menu-heading">Compose a Fax </span>
    <span class="close" (click)="closeTaskSelectionMenu()">X</span>
  </div>

  <form #myForm="ngForm" (ngSubmit)="saveChanges($event, myForm)">
    <div>
      <div class="text-danger text-center p-1" *ngIf="sendFaxError">
        <small>{{ sendFaxErrorMessage }}</small>
      </div>
      <!-- <div class="text-danger text-center p-1" *ngIf="FileTypeError">
        <small>{{ FileTypeErrorMessage }}</small>
      </div> -->
      <div class="text-danger text-center p-1" *ngIf="name.invalid && (name.touched || isSubmitted)">
        <small>Please enter the fax number you would like to send to.</small>
      </div>
      <div class="text-danger text-center p-1" *ngIf="toCheckFileCount">
        <small>You must specify at least one file to send.</small>
      </div>
      <div class="text-danger text-center p-1" *ngIf="isContentCheck">
        <small>The fax content is empty. Please enter the message that would like to send to.</small>
      </div>

      <div class="row m-2">
        <div class="col-6">
          <div class="row">
            <div class="col-3"><label>Send To</label></div>
            <div class="col-7">
              <select name="page" (change)="onDropdownChange()" [(ngModel)]="selectedOption.value">
                <ng-container *ngFor="let search of sendToComposition; let i = index">
                  <option>{{ search.label }}</option>
                </ng-container>
              </select>

              <div class="form-row" [hidden]="!showTextbox">
                <!-- <div id="myField">
                  <p class="required error">
                    <label for="username">Username:</label>
                    <input
                      type="text"
                      name="username"
                      id="username"
                      class=""
                      maxlength="10"
                      value=""
                      title="Username"
                      required
                    />
                  </p>
                </div> -->
                <div class="input-data">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    ngModel
                    required
                    #name="ngModel"
                    [(ngModel)]="toNumber"
                    class="text-value"
                  />
                </div>
                <!-- <div class="text-danger">
                 
                  <small *ngIf="name.invalid && (name.touched || isSubmitted)"
                    >Please enter the fax number you would like to send to.</small
                  >
                </div> -->
                <!-- <small *ngIf="name.errors?.['required']">You must specify at least one file to send.</small>
                  <small *ngIf="name.errors?.['required']"
                    >The fax content is empty. Please enter the message that would like to send to.</small
                  > -->
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-3 formFont"><label>Send From</label></div>
            <div class="col-7">
              <select name="page" [(ngModel)]="fromNumber">
                <ng-container *ngFor="let search of GetCompositionfromSend; let i = index">
                  <option [value]="search.value">{{ search.label }}</option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="row">
            <div class="col-3 formFont"><label>Header Text</label></div>
            <div class="col-7">
              <!-- <input
                type="text"
                class="text-value"
                style="padding-bottom: 0.5rem; width: 15rem"
                [(ngModel)]="headerTextValue"
              /> -->
              <div class="input-data">
                <input
                  type="text"
                  name="name"
                  id="name"
                  ngModel
                  required
                  #name="ngModel"
                  [(ngModel)]="headerTextValue"
                  class="text-value"
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-3 formFont"><label>Cover Page</label></div>
            <div class="col-7">
              <select name="page">
                <ng-container *ngFor="let search of coverPageComposition; let i = index">
                  <option>
                    {{ search.label }}
                  </option>
                </ng-container>
              </select>
            </div>
          </div>
        </div>
        <!-- <div header="Compose Text1" (click)="setSelectedTab('ComposeText')">
          <label>test</label> 
        </div>-->
        <p-tabView [(ActiveIndex)]="activeTabIndex" (onChange)="setSelectedTab($event)" class="fax_tabs">
          <div header="Compose Text1"></div>
          <p-tabPanel header="Compose Text" class="p-tabview-title">
            <span (click)="setSelectedTab('ComposeText')" class="tabtxt-label"></span>
            <app-tinymce-rich-text-editor
              [editorContent]="editorContent"
              (updatedEditorContent)="editorContentHandler($event)"
            ></app-tinymce-rich-text-editor>
          </p-tabPanel>
          <!-- <p-tabPanel header="Attach a File" (click)="setSelectedTab('AttachFile')"> -->
          <p-tabPanel header="Attach a File" cla="p-tabview-title">
            <div *ngIf="fileInputsToShow" class="row mb-2">
              <div class="col-1 customWidth">
                <button class="customButton" style="margin: 2px 0 0 0; border: none" (click)="removeFileInputDefault()">
                  X
                </button>
              </div>

              <div class="col-5">
                <input class="form-control file-upload" type="file" id="formFile" (change)="handleFileInput($event)" />
              </div>
            </div>

            <div *ngFor="let input of fileInputs" class="row mb-2">
              <div class="col-1">
                <button
                  class="customButton"
                  style="margin: 2px 0 0 0; border: none"
                  (click)="removeFileInput(input.id)"
                >
                  X
                </button>
              </div>
              <div class="col-5">
                <input class="form-control file-upload" type="file" id="formFile" (change)="handleFileInput($event)" />
              </div>
            </div>
            <br />
            <button type="button" (click)="addFileInput($event)" style="border: none">
              <label for="">+Add Another File </label>
            </button>
          </p-tabPanel>
        </p-tabView>

        <!-- <div class="accordion-item" id="accordionThree"> -->
        <!-- <h2
          class="accordion-header accordion-button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseThree"
          aria-expanded="true"
          aria-controls="collapseThree"
        >
          <label for="" class="MainMenu">Attach a File</label>
        </h2> -->
        <!-- <hr class="solid-headerDivider" /> -->

        <!-- <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionThree"> -->
        <!-- <div class="accordion-body" *ngIf="fileInputsToShow" class="row">
            <div class="col-2 formFont">
              <button style="margin-right: 10px" class="MainMenu" (click)="removeFileInputDefault()">X</button>
            </div>
            <div class="col-7">
              <input class="form-control file-upload" accept=".mp3,audio/*" type="file" id="formFile" />
            </div>
          </div> -->

        <!-- <div *ngFor="let input of fileInputs" class="row">
            <div class="col-2 formFont"><button class="MainMenu" (click)="removeFileInput(input.id)">X</button></div>
            <div class="col-7">
              <input class="form-control file-upload" accept=".mp3,audio/*" type="file" id="formFile" />
            </div>
          </div> -->

        <!-- <div *ngIf="fileInputsToShow">
        <input class="form-control file-upload" accept=".mp3,audio/*" type="file" id="formFile" />
      </div> -->
        <!-- <button (click)="addFileInput()"><label for="">+Add Another File </label></button> -->
        <!-- <div ngFor="let input of fileInputs; let i = index" class="file-upload">
      <input type="file" />
    </div> -->
        <!-- </div> -->

        <!-- <div>
    <hr class="solid-divider" />
  </div> -->
      </div>
      <!-- </div> -->
      <div class="m-3 text-end">
        <!-- <div class="m-3 text-end"> -->
        <button class="main-btn" type="submit" value="Send">Send</button>
        <button class="outline-btn ms-2" type="button" value="Cancel" (click)="closeTaskSelectionMenu()">Cancel</button>
        <!-- </div> -->

        <!-- <button class="main-btn" type="submit" value="Send" (click)="saveChanges($event, myForm)">Send</button>
        <button class="outline-btn ms-2" type="submit" value="Cancel" (click)="closeTaskSelectionMenu()">Cancel</button> -->
      </div>
    </div>
  </form>
</div>
